const pattern = /^[0-9+ -]{8,16}$/;
export default function (value) {
    return pattern.test(value);
}